module.exports = __webpack_public_path__ + "static/media/download.0c382b16.svg";